import '../lib/sentry';
import '../lib/rails_ujs';
import Turbolinks from 'turbolinks';
import * as ActiveStorage from '@rails/activestorage';
import '../css/application.scss';
import '../css/tailwind.scss';
import { AwsRum } from 'aws-rum-web';
import '../utils/font-injector';

import { registerLazyComponents, buildLazyRegistryFromGlob, buildEagerRegistryFromGlob, setupTurbolinksIntegration, registerContextProvider } from '../lib/vite-react-mount';
import { AppContextProvider } from '../components/application/app-context/AppContext';

Turbolinks.start();
ActiveStorage.start();

// Eagerly bundle nav components so the sidebar mounts synchronously on first page load
// without requiring extra HTTP round-trips for dynamic chunk fetching.
const navModules = import.meta.glob('../components/application/nav/**/*.{tsx,ts,jsx,js}', { eager: true });
registerLazyComponents(buildEagerRegistryFromGlob(navModules, '../components/application/'));

const modules = import.meta.glob([
  '../components/application/**/*.{tsx,ts,jsx,js}',
  '!../components/application/nav/**/*.{tsx,ts,jsx,js}',
]);
registerLazyComponents(buildLazyRegistryFromGlob(modules, '../components/application/'));

const legacyModules = import.meta.glob([
  '../components/admin/**/*.{tsx,ts,jsx,js}',
  '../components/student-recruiter/**/*.{tsx,ts,jsx,js}',
]);
registerLazyComponents(buildLazyRegistryFromGlob(legacyModules, '../components/'));

registerContextProvider(AppContextProvider);
setupTurbolinksIntegration();

if (import.meta.env.DEV) {
  Promise.all([import('react'), import('react-dom'), import('@axe-core/react')]).then(
    ([{ default: React }, { default: ReactDOM }, { default: axe }]) => {
      axe(React, ReactDOM, 1000);
    }
  );
}

if (typeof RUM_APP_ID !== 'undefined' && RUM_APP_ID) {
  try {
    const config = {
      sessionSampleRate: 1,
      guestRoleArn: 'arn:aws:iam::001262764851:role/RUM-Monitor-us-west-2-001262764851-7515169659961-Unauth',
      identityPoolId: 'us-west-2:b42e024f-ab27-4871-904c-df527345cf2f',
      endpoint: 'https://dataplane.rum.us-west-2.amazonaws.com',
      telemetries: ['performance', 'errors', 'http'],
      allowCookies: true,
      enableXRay: false,
      disableAutoPageView: true,
    };

    const APPLICATION_ID = RUM_APP_ID;
    const APPLICATION_VERSION = '1.0.0';
    const APPLICATION_REGION = 'us-west-2';

    const awsRum = new AwsRum(
      APPLICATION_ID,
      APPLICATION_VERSION,
      APPLICATION_REGION,
      config,
    );

    const keysPrecedingUids = [
      'accounts',
      'smart-forms',
      'variants',
      'hubs',
      'user-invites',
      'users',
      'smart-form-template',
      'qr',
      'builder',
    ];

    const notUids = [
      'billboard',
      'results-page',
      'publishing',
    ];

    const recordRumPageView = (awsRum) => {
      const segments = window.location.pathname.split('/');
      const pageTags = [];

      segments.forEach((segment, index, arr) => {
        if (keysPrecedingUids.includes(segment)
          && index + 1 < arr.length
          && !notUids.includes(arr[index + 1])) {
          pageTags.push(`${segment}: ${arr[index + 1]}`);
          arr[index + 1] = '*';
        }
      });

      const pageId = segments.join('/');
      awsRum.recordPageView({ pageId, pageTags });
    };

    document.addEventListener('turbolinks:load', () => {
      recordRumPageView(awsRum);
    });
  } catch (error) {
    // Ignore errors thrown during CloudWatch RUM web client initialization
  }
}
